import { useMutation } from "react-query";
import {
  getExternalAuthToken,
  sendUserInvite,
} from "../../../services/settings";
import { makeRefundStatusUpdate } from "../../../services/expenses";

export const useGetExternalAuthToken = () => {
  return useMutation({
    mutationFn: () => getExternalAuthToken(),
  });
};

export const useSendUserInvite = () => {
  return useMutation((data) => sendUserInvite(data));
};

export const useMakeRefundStatusMutation = () => {
  return useMutation((data) => makeRefundStatusUpdate(data));
};
